import { Clock4, Crown, Sparkles } from "lucide-react";

function fmt(s) {
  const m = Math.floor(Math.max(0, s) / 60);
  const sec = Math.max(0, s) % 60;
  return `${m}:${String(sec).padStart(2, "0")}`;
}

export default function UsageTimerBanner({ timer, onUpgrade }) {
  if (!timer) return null;
  if (timer.is_premium_admin) return null;
  if ((timer.unlocked_project_ids || []).length > 0 && timer.seconds_remaining <= 0) {
    return null; // user has at least one paid project; no need to nag
  }

  const s = Math.max(0, timer.seconds_remaining);
  const total = Math.max(1, timer.initial_seconds || 180);
  const pct = Math.max(0, Math.min(100, (s / total) * 100));
  const critical = s <= 30;
  const warn = s <= 60 && !critical;
  const tone = critical
    ? "bg-[#FBEFEA] border-[#B6533F]/40 text-[#7a2e1f]"
    : warn
    ? "bg-[#FBF6EC] border-copper/40 text-[#7a5a18]"
    : "bg-white border-rule text-ink";
  const barColor = critical ? "bg-[#B6533F]" : warn ? "bg-copper" : "bg-forest";

  return (
    <div
      data-testid="usage-timer-banner"
      data-critical={critical ? "true" : "false"}
      className={`mx-4 lg:mx-8 mt-4 rounded-2xl border ${tone} px-4 py-3 flex items-center gap-3`}
    >
      <span className="grid place-items-center h-9 w-9 shrink-0 rounded-full bg-white border border-rule">
        <Clock4 size={15} className={critical ? "text-[#B6533F]" : warn ? "text-copper" : "text-forest"} />
      </span>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-3">
          <p className="text-[10px] tracking-[0.22em] uppercase font-medium">
            Tiempo de prueba activo
          </p>
          <p data-testid="usage-timer-value" className="font-mono text-[14px] tabular-nums font-medium">
            {fmt(s)}
          </p>
        </div>
        <div className="mt-1.5 h-1.5 w-full rounded-full bg-paper-2 overflow-hidden">
          <div
            className={`h-full ${barColor} transition-[width] duration-700 ease-out`}
            style={{ width: `${pct}%` }}
          />
        </div>
        <p className="mt-1 text-[11.5px] leading-snug">
          {critical ? (
            <>Te quedan menos de 30 segundos. <span className="font-medium">Desbloquea por $69 USD</span> antes de que el editor se congele.</>
          ) : warn ? (
            <>El cronómetro corre sólo cuando estás interactuando. Recuerda: el desbloqueo es de por vida con un pago único.</>
          ) : (
            <>3 minutos para probar todo el sistema. Tu progreso se guarda automáticamente.</>
          )}
        </p>
      </div>
      <button
        data-testid="usage-timer-upgrade"
        onClick={onUpgrade}
        className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-[12px] font-medium text-[#1d2c22] bg-[#E0C58A] hover:bg-[#EBD8A8] whitespace-nowrap"
      >
        <Crown size={12} />
        Desbloquear $69
      </button>
    </div>
  );
}
